var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-container",attrs:{"id":"customModal"},on:{"click":function (event) { return _vm.closeModal(event); }}},[_c('div',{staticClass:"modal-content"},[_c('article-modal-content',{attrs:{"res":_vm.getModalDetails}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }